function validateCard(card) {
    card = card || {};
    var errors = [];

    if (!card.number) {
        errors.push({ property_path: 'card.number', message: 'A card number is required.' });
    }
    if (!card.name) {
        errors.push({ property_path: 'card.name', message: 'A name is required.' });
    }
    if (!card.expiryMonth) {
        errors.push({ property_path: 'card.expiryMonth', message: 'An expiry month is required.' });
    }
    if (!card.expiryYear) {
        errors.push({ property_path: 'card.expiryYear', message: 'An expiry year is required.' });
    }
    if (!card.cvn) {
        errors.push({ property_path: 'card.cvn', message: 'A CVN is required.' });
    }

    return errors;
}

function validateCvn(card) {
    card = card || {};
    var errors = [];

    if (!card.cvn) {
        errors.push({ property_path: 'card.cvn', message: 'A CVN is required.' });
    }

    return errors;
}

export default {
    validateCard,
    validateCvn
};



// WEBPACK FOOTER //
// ./app/validators/CardValidator.js